// tirando processamento do back
const moment = require("moment");

const each = {
  fiveMin: 0.083,
  halfHour: 0,
  halfHour: 0.5,
  hour: 1,
  threeHours: 3,
  sixHours: 6,
  twelveHours: 12,
  // day: 0
  day: 24
};
/**
 * Remover datas repetidas
*/
function removeDuplicatedTimes(table, sign = "desc") {
  const flatArray = [...table.flat()];
  flatArray.sort(function (a, b) {
    var c = new Date(a);
    var d = new Date(b);
    if (sign == "asc") {
      return c - d;
    }
    return d - c;
  });
  const filteredData = flatArray.reduce((ac, time) => {
    if (ac.indexOf(time) < 0) ac.push(time);
    return ac;
  }, []);
  return Array.from([...filteredData], t => Array.of(t));
}
/**
 *
 * @param {array} logs
 * @param {array} table
 * @param {object} data
 * @param {string} EQP
 * @returns
 */
function joinTables(logs, table, data, EQP) {
  let { type } = data;
  let orderColumns = [];
  let currentItem = 0;
  const tables = [];
  let numberOfElements = logs.length;
  for (let i = 0; i < numberOfElements; i++) {
    currentItem++;
    let info = logs[i];
    if (info.length) {
      let title = info.splice(0, 1);
      let lengthInfo = info.length;
      let lengthTable = table.length;
      if (lengthTable > lengthInfo) {
        for (let e = lengthInfo + 1; e <= lengthTable; e++) {
          info.push([]);
        }
      }
      let position = 0;
      //
      for (let x = 0; x < lengthTable; x++) {
        //Se o tempo de table for igual ao tempo de log[i]
        if (table[x][0] == info[x - position][0]) {
          if (EQP == "SENSOR") {
            //Se o tempo de table for igual ao tempo de log[i]
            if (data.type == "measure") {
              info[x - position].splice(0, 1);
              //Percorrer as colunas de info para juntar com table, desconsiderando a data
              info[x - position].forEach(column => {
                table[x].push(column);
              });
            } else {
              console.log(
                "warning: ",
                "Erro na geração de relatório ao detectar o tipo de relatório"
              );
              //Para cada um das colunas, irá adicionar espaço vazio
              for (let i = 1; i >= title[0].length; i++) {
                table[x].push(" ");
              }
            }
          } else {
            info[x - position].splice(0, 1);
            //Percorrer as colunas de info para juntar com table, desconsiderando a data
            info[x - position].forEach(column => {
              table[x].push(column); // Juntar dados que possuem o mesmo PERÍODO
            });
          }
        } else {
          for (let i = 1; i <= title[0].length - 1; i++) {
            // Adicionar espaço vazio nas outras colunas tirando o PERÍODO
            table[x].push(" ");
          }
          position++;
        }

        // Adicionar nomes das colunas
        if (x + 1 >= lengthTable) {
          try {
            //Percorre todas as colunas do título, não começando pelo PERÍODO
            for (let i = 1; i <= title[0].length - 1; i++) {
              orderColumns.push(title[0][i]);
            }
          } catch (e) {
            for (let i = 1; i <= title[0].length - 1; i++) {
              orderColumns.push("?");
            }
          }
        }
      }
    }
  }
  // Montar a tabela
  if (currentItem == numberOfElements) {
    if (EQP === "DIR") {
      if (["battery", "stat"].includes(type)) {
        makeTable(table, data, function (t) {
          orderColumns.splice(0, 0, "PERÍODO");

          t.splice(0, 0, orderColumns);
          tables.push(t);
        });
      } else {
        tables.push([]);
      }
    } else if (EQP === "ACTUATOR") {
      let types = ["flow", "modo", "open"];
      if (type == "volume") {
        makeTable(table, data, function (t) {
          orderColumns.splice(0, 0, "DATA");
          t.splice(0, 0, orderColumns);
          tables.push(t);
        });
      } else if (types.indexOf(type) > -1) {
        makeTable(table, data, function (t) {
          orderColumns.splice(0, 0, "PERÍODO");
          t.splice(0, 0, orderColumns);
          tables.push(t);
        });
      } else {
        tables.push([]);
      }
    } else if (EQP === "SENSOR") {
      if (type == "measure") {
        makeTable(table, data, function (t) {
          orderColumns.splice(0, 0, "PERÍODO"); //add o titulo da segunda coluna com o periodo
          t.splice(0, 0, orderColumns); //add a primeira linha da table os titulos
          tables.push(t);
        });
      } else {
        // table[x].push(0);//caso sim, add a table
        tables.push([]);
      }
    }

    return tables;
  }
}
function sensorLogs(reportsTable, data, callback) {
  let onlyTimes = [];
  reportsTable.forEach(({ table }) => {
    let array = JSON.parse(JSON.stringify(table));
    onlyTimes = [...onlyTimes, ...array];
  });
  let times_table = removeDuplicatedTimes(onlyTimes, "desc");
  onlyTimes = [];
  const tables = [];
  // Montar para cada sensor selecionado um gráfico
  for (let { logs, table } of reportsTable) {
    let orderColumns = [];
    let numberOfElements = logs.length;
    for (let i = 0; i < numberOfElements; i++) {
      encapsuleSensorArr(logs[i], function (info) {
        let lengthInfo = info.length;
        let lengthTable = table.length;
        if (lengthTable > lengthInfo) {
          for (let e = lengthInfo + 1; e <= lengthTable; e++) {
            info.push([[]]);
          }
        }
        let position = 0;
        //
        for (let x = 0; x < lengthTable; x++) {
          //Juntar dados com a mesmo tempo
          if (table[x][0] == info[x - position][0][0]) {
            if (data.type == "measure") {
              let line = info[x - position][0][3];
              line = line.toFixed(1);
              table[x].push(line);
            } else {
              console.log(
                "warning: ",
                "Erro na geração de relatório ao detectar o tipo de relatório"
              );
              // table[x].push(0);
              table[x].push(" ");
            }
          } else {
            table[x].push(" ");
            position++;
          }

          if (x + 1 >= lengthTable) {
            try {
              let name = `${info[x - position][0][1]} - ${info[x - position][0][6]
                } (${info[x - position][0][2]})`;
              //Adicina o título na coluna com os dados do sensor
              orderColumns.push(name);
            } catch (e) {
              orderColumns.push("?");
            }
          }

          // #junta tudo
          if (numberOfElements + 1 == table[0].length && x + 1 == lengthTable) {
            //verifica se finalizou o loop, o +1 é por causa de data
            if (data.type == "measure") {
              makeTable(table, data, function (table) {
                orderColumns.splice(0, 0, "PERÍODO"); //add o titulo da segunda coluna com o periodo
                table.splice(0, 0, orderColumns); //add a primeira linha da table os titulos
                tables.push(table);
              });
            } else {
              // table[x].push(0);//caso sim, add a table
              tables.push([]);
            }
          }
        }
      });
    }
  }
  const groupedTables = joinTables(tables, times_table, data, 'SENSOR');
  if (groupedTables.length) {
    callback({
      status: true,
      table: groupedTables
    });
  } else {
    callback({
      status: false,
      table: "Erro na geração de relatório ao detectar o tipo de relatório"
    });
  }
}

function dirLogs(reportsTable, data, callback) {
  //Table com TIME não repetidos
  let onlyTimes = [];
  reportsTable.forEach(({ table }) => {
    let array = JSON.parse(JSON.stringify(table));
    onlyTimes = [...onlyTimes, ...array];
  });
  let times_table = removeDuplicatedTimes(onlyTimes, "asc");
  onlyTimes = [];
  const tables = [];
  for (let { logs, table } of reportsTable) {
    let orderColumns = [];
    let numberOfElements = logs.length;
    for (let i = 0; i < numberOfElements; i++) {
      encapsuleDirArr(logs[i], function (info) {
        let lengthInfo = info.length;
        let lengthTable = table.length;
        // igualar o tamanho do array de INFO para ficar do mesmo tamanho do TABLE
        if (lengthTable > lengthInfo) {
          for (let e = lengthInfo + 1; e <= lengthTable; e++) {
            info.push([[]]);
          }
        }
        let position = 0;
        for (let x = 0; x < lengthTable; x++) {
          if (table[x][0] == info[x - position][0][0]) {
            if (data.type == "battery") {
              let line = info[x - position][0][2];
              line = line.toFixed(1);
              table[x].push(line);
            } else if (data.type == "stat") {
              table[x].push(info[x - position][0][3]);
            } else {
              console.log(
                "warning: ",
                "Erro na geração de relatório ao detectar o tipo de relatório"
              );
              // table[x].push(0);
              table[x].push(" ");
            }
          } else {
            table[x].push(" ");
            position++;
          }
          let name = "";
          if (x + 1 >= lengthTable) {
            try {
              // let name = ""
              if (data.type == "battery") {
                name = info[x - position][0][1] + " (V)";
              } else if (data.type == "stat") {
                name = info[x - position][0][1] + " (%)";
              }

              orderColumns.push(name);
            } catch (e) {
              orderColumns.push("?");
            }
          }
          if (numberOfElements + 1 == table[0].length && x + 1 == lengthTable) {
            if (["battery", "stat"].includes(data.type)) {
              makeTable(table, data, function (t) {
                orderColumns.splice(0, 0, "PERÍODO");

                t.splice(0, 0, orderColumns);
                tables.push(t);
              });
            } else {
              tables.push([]);
            }
          }
        }
      });
    }
  }
  const groupedTables = joinTables(tables, times_table, data, 'DIR');
  if (groupedTables.length) {
    callback({
      status: true,
      table: groupedTables
    });
  } else {
    callback({
      status: false,
      table: "Erro na geração de relatório ao detectar o tipo de relatório"
    });
  }
}

function separeLogsPerDate(elem, dates, callback) {
  let result = {};
  dates.map(date => {
    result[date[0]] = [];
    for (let i = 0; i < elem.length; i++) {
      result[date[0]] = [
        ...result[date[0]],
        ...elem[i].VALUE.filter(e => date[0] == e.TIME).map(e =>
          Object.assign(e, {
            NAME: elem[i].NAME
          })
        )
      ];
    }
  });
  callback(result);
}

function actuatorLogs(reportsTable, data, callback) {
  let { type } = data;
  let times_table = [];
  const tables = [];
  //table = registros de todos as datas sem possuir repetição
  for (let { logs, table } of reportsTable) {
    logs = logs.filter(log => log.VALUE.length);
    if (logs.length) {
      let headers = logs.map(e => e.NAME); // posição das colunas por nome
      table = table.map(e => {
        // todas as linhas [horario + qt de colunas = qt de elementos]
        return [...e, ...Array(logs.length).fill(" ")];
      });
      // Agrupar logs por data
      //
      separeLogsPerDate(logs, table, result => {
        //Table não tem data repetidas
        for (let i = 0; i < table.length; i++) {
          //Caso tenha registros com datas repetidas irá percorrer todos eles
          result[table[i][0]].forEach(resultItem => {
            let index = headers.indexOf(resultItem.NAME);
            // table[i][index + 1] = DADO; // +1 pra skipar a coluna da hora
            if (type == "flow") {
              table[i][index + 1] = resultItem.OPEN == 1 ? resultItem.FLOW : 0;
            } else if (type == "volume") {
              /*
                  table[i][index+1]=[data:string,{
                    VOL:number,
                    OPEN:number
                  }]
              */
              //Se na tabela existe algum registro de volume
              if (!!table[i][index + 1] && table[i][index + 1] !== " ") {
                //Só sobrescrever os dados da tabela se  OPEN 1
                if (
                  (table[i][index + 1].OPEN === 1 && resultItem.OPEN === 1) ||
                  (table[i][index + 1].OPEN === 0 && resultItem.OPEN === 1)
                ) {
                  table[i][index + 1] = {
                    VOL: resultItem.VOL,
                    OPEN: resultItem.OPEN
                  };
                }
              }
              // Caso não tenha registros na tabela então irá criar um novo após a data
              else {
                table[i][index + 1] = {
                  VOL: resultItem.VOL,
                  OPEN: resultItem.OPEN
                };
              }
            } else if (type == "modo") {
              let modo = ["automático", "manual"];
              table[i][index + 1] = modo[resultItem.MANUAL];
            } else if (type == "open") {
              let modo = ["fechada", "aberta"];
              table[i][index + 1] = modo[resultItem.OPEN];
            } else {
              console.log(
                "Erro na geração de relatório ao detectar o tipo de relatório."
              );
              table[i][index + 1] = " ";
            }
          });
        }


        headers = headers.map(e => {
          if (type == "volume" && logs[0].VALUE && logs[0].VALUE[0].IS_FIR) e += ` (litros)`
          else if (type == "volume") e += ` (m³)`;
          else if (type == "flow") e += ` (m³/h)`;
          return e;
        });

        let types = ["flow", "modo", "open"];
        if (type == "volume") {
          calculeVolume(table, data, function (tableVolume) {
            tableVolume.map(col => {
              times_table.push([col[0]]);
            });
            //Adicionar o título 'DATA' para a coluna com todas as datas
            headers.splice(0, 0, "DATA");
            tableVolume.splice(0, 0, headers);

            // callback({
            //   status: true,
            //   table: tableVolume
            // });
            tables.push(tableVolume);
          });
        } else if (types.indexOf(type) > -1) {
          makeTable(table, data, function (t) {
            //Registrar as datas da tabela criada no array com todas as datas incluindo de outras tabelas
            t.map(col => {
              times_table.push([col[0]]);
            });
            //Adicionar 'PERÍODO' como título dos dados que possuem só tempo
            headers.splice(0, 0, "PERÍODO");
            t.splice(0, 0, headers);
            tables.push(t);
          });
        } else {
          tables.push([]);
        }
      });
    } else {
      tables.push([]);
    }
  }

  let times = [];
  if (type == "volume") {
    times = removeDuplicatedTimes(times_table, "asc");
  } else {
    times = removeDuplicatedTimes(times_table, "desc");
  }

  const groupedTables = joinTables(tables, times, data, 'ACTUATOR');

  if (groupedTables.length) {
    callback({
      status: true,
      table: groupedTables
    });
  } else {
    callback({
      status: false,
      table: "Erro na geração de relatório ao detectar o tipo de relatório"
    });
  }
}

function organizeToTable(tableData, data, callback) {
  /* VÁLVULAS */
  if (data.equipment == "actuator") {
    actuatorLogs(tableData, data, function (result) {
      callback(result);
    });
  } else if (data.equipment == "sensor") {
    /* FIM DE VÁLVULAS */
    /* SENSORES */
    sensorLogs(tableData, data, function (result) {
      callback(result);
    });
  } else if (data.equipment == "device") {
    /* FIM DE SENSORES */
    /* DIRS */
    dirLogs(tableData, data, function (result) {
      callback(result);
    });
  }
  /* FIM DE DIRS */
}

/* Funções de encapsulamento */

function encapsuleSensorArr(rows, callback) {
  let toBroker = [];
  let linha = [];
  for (let i = 0; i < rows.VALUE.length; i++) {
    let info = [];
    info.push(rows.VALUE[i].TIME);
    info.push(rows.NAME);
    info.push(rows.VALUE[i].UNIT);
    info.push(rows.VALUE[i].VALUE);
    info.push(rows.VALUE[i].MIN_VALUE);
    info.push(rows.VALUE[i].MAX_VALUE);
    info.push(rows.VALUE[i].TYPE);
    info.push(rows.VALUE[i].POS);
    linha.push(info);

    let encapsulate = [];
    encapsulate.push(linha[i]);
    toBroker.push(encapsulate);
  }

  callback(toBroker);
}

function encapsuleDirArr(rows, callback) {
  let toBroker = [];
  let linha = [];
  for (let i = 0; i < rows.VALUE.length; i++) {
    let info = [];
    info.push(rows.VALUE[i].TIME);
    info.push(`DIR-${rows.NAME}`);
    info.push(rows.VALUE[i].BAT);
    info.push(rows.VALUE[i].STAT_RF);
    linha.push(info);

    let encapsulate = [];
    encapsulate.push(linha[i]);
    toBroker.push(encapsulate);
  }

  callback(toBroker);
}
/* Fim: funções de encapsulamento */

function sliceByDays(table, callback) {
  //slice the table by days, if the table has data of days 01, 02 and 03, the result will be 3 tables, one for each day
  let volumeByDays = "";
  let splicedTable = [];
  let result = [];
  for (let z = 0; z < table.length; z++) {
    if (z == 0) {
      volumeByDays = table[z][0];
    }

    if (volumeByDays == table[z][0]) {
      splicedTable.push(table[z]);
    } else {
      result.push(splicedTable);
      volumeByDays = table[z][0];
      splicedTable = [];
      splicedTable.push(table[z]);
    }

    if (z + 1 == table.length) {
      result.push(splicedTable);
      callback(result);
    }
  }
}

function dateGenerator(base, callback) {
  let datetime = base.split(" ");
  let time = datetime[1];
  let date = datetime[0].split("-");
  callback(`${date[2]}/${date[1]}/${date[0]} ${time}`);
}

function occurrence(arr) {
  let distinctValues = arr.filter((e, i, arr) => arr.indexOf(e) == i);
  let values = arr;
  let valuesToNumber = values.map(e => {
    //transformando values em array de indexes correspondentes aos elementos de distinctValues
    for (let i = 0; i < distinctValues.length; i++) {
      if (e == distinctValues[i]) return i;
    }
  });

  let occurrences = Array(distinctValues.length).fill(0); //vai guardar quantas vezes aparece cada item de distinctValues em values
  for (let j = 0; j < valuesToNumber.length; j++) {
    occurrences[valuesToNumber[j]] += 1; //contador de ocorrências do elemento de distinctValues em values
  }
  let appearsMore = null;
  let appearsMoreArray = [];
  let highestOccurrence = -1;
  for (let k = 0; k < occurrences.length; k++) {
    if (occurrences[k] > highestOccurrence) {
      appearsMore = k;
      if (appearsMoreArray.length) appearsMoreArray = [];
      appearsMoreArray.push(distinctValues[k]);
      highestOccurrence = occurrences[k];
    } else if (occurrences[k] == highestOccurrence) {
      appearsMoreArray.push(distinctValues[k]);
    }
  }
  if (appearsMoreArray.length > 1) {
    return appearsMoreArray;
  } else {
    return distinctValues[appearsMore];
  }
}

function sliceBy(details, start, table, callback) {
  let { interval, unit, type } = details;
  let base = start;
  let limit = moment(base)
    .add(interval, unit)
    .format("YYYY-MM-DD HH:mm");
  let dataPerInterval = [];
  let result = [];
  for (let idx = 0; idx < table.length; idx++) {
    // table = table.map(item => {
    let item = table[idx];
    // let formattedItemDatetime = moment(item[0], ['DD/MM/YYYY HH:mm']).format('YYYY-MM-DD HH:mm');
    // if (formattedItemDatetime < limit) {
    if (item[0] < limit) {
      dateGenerator(base, function (datetime) {
        item[0] = datetime;
        dataPerInterval.push(item);
      });
    } else {
      result.push(dataPerInterval);
      base = limit;
      limit = moment(base)
        .add(interval, unit)
        .format("YYYY-MM-DD HH:mm");
      dataPerInterval = [];
      dateGenerator(base, function (datetime) {
        if (type == "volume") {
          // se for volume, ao trocar o intervalo, é necessário salvar
          // referência para acúmulo de volume
          table[idx - 1][0] = datetime;
          dataPerInterval.push(table[idx - 1]);
        }
        item[0] = datetime;
        dataPerInterval.push(item);
      });
    }
    if (idx + 1 == table.length) {
      result.push(dataPerInterval);
      callback(result);
    }
  } // });
}

function sliceByInterval(data, table, callback) {
  //slice the table by interval, if the table has data of more than one period, the result will be this number of tables, one for each interval
  let { interval, start, type } = data;
  let intervalDetails = {
    interval,
    type
  };
  if (interval == each.day) {
    table = table.map(i => {
      i[0] = i[0].split(" ")[0];
      return i;
    });
    let day;
    let dataPerDay = [];
    let result = [];
    for (let idx = 0; idx < table.length; idx++) {
      if (idx == 0) day = table[idx][0];

      if (day == table[idx][0]) {
        dataPerDay.push(table[idx]);
      } else {
        // o primeiro log do dia seguinte entra pra soma de volume
        // pois a diferença desse log para o anterior é do intervalo de 23:55 - 00:00
        result.push(dataPerDay);
        day = table[idx][0];
        dataPerDay = [];
        dataPerDay.push(table[idx]);
      }

      if (idx + 1 == table.length) {
        result.push(dataPerDay);
        callback(result);
      }
    }
  } else if (interval > each.halfHour) {
    intervalDetails.unit = "hours";
    sliceBy(intervalDetails, start, table, function (result) {
      callback(result);
    });
  } else {
    intervalDetails.interval = 30;
    intervalDetails.unit = "minutes";
    sliceBy(intervalDetails, start, table, function (result) {
      callback(result);
    });
  }
}

function makeTable(table, data, callback) {
  if (data.interval == each.fiveMin) callback(table);
  else {
    sliceByInterval(data, table, function (groupByIntervals) {
      let { organization } = data;
      let tb = [];
      let numberOfIntervals = groupByIntervals.length;
      // pegar o valor apenas do primeiro log por intervalo
      for (let period = 0; period < numberOfIntervals; period++) {
        let tbLine = [];
        try {
          let thisInterval = groupByIntervals[period][0][0];
          let numberOfColumns = groupByIntervals[period][0].length;
          for (let col = 1; col < numberOfColumns; col++) {
            if (organization == "raw") {
              let val = groupByIntervals[period][0][col] || "-";
              tbLine.push(val);
            } else {
              let numberOfLines = groupByIntervals[period].length;
              if (organization == "avg") {
                let qt = 0;
                let sum = 0;
                for (let line = 0; line < numberOfLines; line++) {
                  if (typeof groupByIntervals[period][line][col] == "number") {
                    qt++;
                    sum += groupByIntervals[period][line][col];
                  }
                }
                if (qt > 0) {
                  let avg = sum / qt;
                  tbLine.push(avg.toFixed(3));
                } else {
                  tbLine.push("-");
                }
              } else if (organization == "occ") {
                let arr = [];
                for (let line = 0; line < numberOfLines; line++) {
                  if (typeof groupByIntervals[period][line][col] != " ") {
                    arr.push(groupByIntervals[period][line][col]);
                  }
                }
                if (arr.length) {
                  tbLine.push(occurrence(arr));
                } else {
                  tbLine.push("-");
                }
              }
            }
          }
          tbLine.splice(0, 0, thisInterval);
          tb.push(tbLine);
          if (period + 1 == numberOfIntervals) {
            callback(tb);
          }
        } catch (e) { }
      }
    });
  }
}

function calculeVolume(table, data, callback) {
  let result = [];
  sliceByInterval(data, table, function (groupByIntervals) {
    let numberOfIntervals = groupByIntervals.length;
    for (let period = 0; period < numberOfIntervals; period++) {
      //sweep by intervals
      let totalVolume = [];
      let thisPeriod = groupByIntervals[period][0][0];
      let numberOfColumns = groupByIntervals[period][0].length;

      //sweep by columns, start in 1 to ignore column with date
      for (let col = 1; col < numberOfColumns; col++) {
        let numberOfLines = groupByIntervals[period].length;

        // referência da última leitura
        let lastMeasurementReference = null;

        let accumulatedVolume = 0;

        // Verificar se irá começar a contagem de volume considerando o último registro do dia anterior
        // MOTIVO: Evitar desconsiderar o último registro de volume do dia anteriores na contegem de volume acumulado do dia seguinte
        if (period > 0) {
          const previousRecords = groupByIntervals[period - 1];

          const [lastPeriod, lastMeasurements] = previousRecords[previousRecords.length - 1];

          const currentDate = new Date(thisPeriod);
          const previousDate = new Date(lastPeriod);

          const diffTime = currentDate.getTime() - previousDate.getTime();
          // calcular diferença em dias (ignorando horário)
          const diffDays = diffTime / (1000 * 60 * 60 * 24);

          // só considerar o último registro se for exatamente 1 dia antes
          if (diffDays === 1) {
            let lastLinePrev = lastMeasurements[col];

            if (typeof lastLinePrev === "object" && lastLinePrev.OPEN === 1) {
              lastMeasurementReference = lastLinePrev.VOL;
            }
          }
        }


        for (let line = 0; line < numberOfLines; line++) {
          //sweep by lines
          if (typeof groupByIntervals[period][line][col] == "object") {
            let atual = groupByIntervals[period][line][col];

            if (atual.OPEN === 1) {
              if (lastMeasurementReference !== null && atual.VOL > lastMeasurementReference) {
                accumulatedVolume += atual.VOL - lastMeasurementReference;
              }
              lastMeasurementReference = atual.VOL;
            } else lastMeasurementReference = null;

          }
        }
        totalVolume.push(accumulatedVolume.toFixed(2));
      }

      totalVolume.splice(0, 0, thisPeriod);
      result.push(totalVolume);

      if (period + 1 == numberOfIntervals) {
        callback(result);
      }
    }
  });
}
/* Fim: funções pra válvula */

/* Tratamento pós organização */
function removeItemsWithoutLog(data, callback) {
  //this happen when not have log to valve/sensor search
  let columns = data[0];
  let withLog = columns
    .filter(column => column != "?")
    .map(item => columns.indexOf(item));

  let justWithLog = [];

  for (let i = 0; i < data.length; i++) {
    justWithLog.push([]);
  }

  let lenNewArr = withLog.length;
  let lenOrigin = data.length;
  for (let x = 0; x < lenNewArr; x++) {
    for (let i = 0; i < lenOrigin; i++) {
      justWithLog[i].push(data[i][withLog[x]]);
      if (x + 1 >= lenNewArr && i + 1 >= lenOrigin) {
        if (justWithLog[0].length == 1) {
          //this mean that all valves search did'nt found log and now in the table just have a preiod column
          callback(
            false,
            "Não há registro para o(s) equipamento(s) buscado(s)"
          );
        } else {
          callback(true, justWithLog);
        }
      }
    }
  }
}
/* Fim: tratamento pós organização */

export { organizeToTable, removeItemsWithoutLog };
